// extracted by mini-css-extract-plugin
export default {"container":"J8_iPG","item":"K1vzPE","label":"Oxp364"};